import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';


@Component({
  selector: 'app-inputType-matrix',
  templateUrl: './inputType-matrix.component.html',
  styleUrls: ['./inputType-matrix.component.scss']
,  standalone: false
})
export class InputTypeMatrixComponent implements OnInit {
  @Input() question: QuestionViewModel;
  @Input() errorMessage: string;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() foregroundcolor: string;
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Input() showName?: boolean=true;
  isMatrix?: boolean=true;
  @Input() backgroundcolor: string;
  @Input() theme: string;
  @Input() controlBGColor: string;
  @Input() controlBorder: string;
  @Input() TextColor: string;
  @Input() IsReadOnly?:boolean=false;
  @Input() tableBorder: string;
  conditionQues: ConditionalQues[] = [];
  
  optStr:string; 
  changeColor:boolean = false;
  validationerrorMessage: string[] = [];
  ngOnInit() {  
    
    this.question.subQuestions.forEach(x=>{
      if(x.inputType == 'mul' || x.inputType == 'chk'){
        this.setIntialResponseTextForMulSubQuestions();
      }
    })   
    if(this.question.errorMessage != null && this.question.errorMessage.length > 0){
      this.validationerrorMessage.push(this.question.errorMessage);
    }
   
  }
  GetChildData(selectedChild: any) 
  {    
    selectedChild.options.forEach((e) =>
    {
      //Update value as selected in conditional ques arr
      this.conditionQues.forEach((element) => {
        if (element.value == e.value && e.selected == true) {
            element.isSelected = true;
          }
        else if (element.value == e.value && e.selected == false){
          element.isSelected = false;
        }
      });
    });
    this.childQuestion.emit(this.question);
  }
  CheckValidations()
  {
    if (this.question.isQuestionRequired == "Y") {
      if (this.question["responseText"] == "" || this.question["responseText"] == null) {
        this.question["IsValid"] = false;
      }
      else {
        this.question["IsValid"] = true;
      }
    }
    else {
      this.question["IsValid"] = true;
    }
    this.childQuestion.emit(this.question);
  }

  onSelectRadio(event,subQuestion,subQueIndex :number,optIndex:number){
    
    subQuestion.options.forEach((e) => { e.selected = false; });   
    subQuestion.options[optIndex].selected = true;
    subQuestion.responseText = this.question.subQuestions[subQueIndex].options[optIndex];
    
    let optionStr = "";    
    subQuestion.options.forEach(element => {
      if(element.selected)
      {
        optionStr += element.value + "||";
      }
    });   
    optionStr = optionStr.substring(0, optionStr.length - 2);
    this.question.subQuestions[subQueIndex]["responseText"] = optionStr;
    this.CheckValidations();
  }
  onSelectChekbox(event,subQuestion,subQueIndex :number,optIndex:number){
        
    if (event.checked === true) {     
      subQuestion.options[optIndex].selected = true;     
    }
    else if (event.checked === false) {     
      subQuestion.options[optIndex].selected = false;
    }
    let optionStr = "";    
    subQuestion.options.forEach(element => {
      if(element.selected)
      {
        optionStr += element.value + "||";
      }
    });   
    optionStr = optionStr.substring(0, optionStr.length - 2);
    this.question.subQuestions[subQueIndex]["responseText"] = optionStr;
    this.CheckValidations();
  }
  onSelectMultiChoice(event,subQuestion,subQueIndex :number,optIndex:number){
    
    this.changeColor = !this.changeColor;
    if (this.changeColor) {
      this.foregroundcolor ="var(--main-color) !important; //#437cbc";this.TextColor = "white";    
      subQuestion.options[optIndex].selected = true  ;    
      event.target.style.backgroundColor = this.foregroundcolor;
      event.target.style.color=this.TextColor;     
    }
    else {  
       this.foregroundcolor ="white";this.TextColor = "";    
      event.target.style.backgroundColor = this.foregroundcolor;
      event.target.style.color=this.TextColor;
      subQuestion.options[optIndex].selected = false;     
    }

    let optionStr = "";    
    subQuestion.options.forEach(element => {
      if(element.selected)
      {
      optionStr += element.value + "||";
      }
    });    
    optionStr = optionStr.substring(0, optionStr.length - 2);
    this.question.subQuestions[subQueIndex]["responseText"] = optionStr;  
    this.CheckValidations();
  }
  setIntialResponseTextForMulSubQuestions(){
    
    this.question.subQuestions.forEach((subQue,subQInd) =>{
      if(subQue.responseText && subQue.responseText.length>0) {
        let arrResp= subQue.responseText.split("||");
        let optSelected=[];
        subQue.options.forEach((x,y)=>{
          let found = arrResp.filter( p => p == x.value)[0];
          let index = arrResp.findIndex(p => p === x.value);
          if(found != null )
          {
            //optSelected.push(y);
            subQue.options[y]["selected"]=true;
            this.question.subQuestions[subQInd].options[y]["selected"]=true;
          }
        });
        //  optSelected.forEach(z=>
        //  {
        //   subQue.options[z]["selected"]=true;             
        //  })

         if (this.question.isQuestionRequired == "Y" && optSelected.length>0) {
          this.question["IsValid"]=true;
          this.childQuestion.emit(this.question);
        }
      }
    });   
  }


}
export class ConditionalQues {
  que: string;
  value: string;
  isSelected?: boolean = false;
}
export class CheckBoxOptions {
  value: string;
  index: number;
  isSelected: boolean;
}

